"use strict";
// Fork-local Links admin gate (not production-grade auth).
// Change ADMIN_PIN below, then rebuild / refresh. Session unlock uses sessionStorage only.
Object.defineProperty(exports, "__esModule", { value: true });
exports.lockAdmin = exports.unlockAdmin = exports.isAdminUnlocked = exports.ADMIN_PIN = void 0;
exports.ADMIN_PIN = '1234';
var SESSION_KEY = 'stremio-web-links-admin-v1';
var isAdminUnlocked = function () {
    try {
        return sessionStorage.getItem(SESSION_KEY) === '1';
    }
    catch (_a) {
        return false;
    }
};
exports.isAdminUnlocked = isAdminUnlocked;
var unlockAdmin = function (pin) {
    if (pin !== exports.ADMIN_PIN) {
        return false;
    }
    try {
        sessionStorage.setItem(SESSION_KEY, '1');
    }
    catch (_a) {
        // ignore quota / private mode
    }
    return true;
};
exports.unlockAdmin = unlockAdmin;
var lockAdmin = function () {
    try {
        sessionStorage.removeItem(SESSION_KEY);
    }
    catch (_a) {
        // ignore
    }
};
exports.lockAdmin = lockAdmin;
